import { render, staticRenderFns } from "./AdminTradeReq.vue?vue&type=template&id=489c5ccc&scoped=true&"
import script from "./AdminTradeReq.vue?vue&type=script&lang=js&"
export * from "./AdminTradeReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c5ccc",
  null
  
)

export default component.exports